export const TodoListTypes = {
  SHOW_ALL_TODO: 'SHOW_ALL_TODO',
  SHOW_TODO_LIST: 'SHOW_TODO_LIST',
  ADD_TODO: 'ADD_TODO',
  DELETE_TODO: 'DELETE_TODO',
  UPDATE_TODO: 'UPDATE_TODO',
  UPDATE_SINGLE: 'UPDATE_SINGLE',
}
